// Runtime configuration accessor.
//
// create-react-app inlines `process.env.REACT_APP_*` at BUILD time, so a
// single built image would otherwise be permanently pinned to whatever
// environment built it. The promotion pipeline crane-copies the dev image
// to prod, which means prod would run dev's URLs baked into the JS bundle.
//
// To break that, the deployed container writes `window._env_` at startup
// (see docker-entrypoint.sh + public/config.js). We read that FIRST and
// fall back to the build-time `process.env.REACT_APP_*` so local
// `npm start` (which has no container/_env_) still works unchanged.
const fromRuntime = (key) =>
  (typeof window !== "undefined" && window._env_ && window._env_[key]) ||
  undefined;

export const config = {
  KEYCLOAK_URL: fromRuntime("KEYCLOAK_URL") || process.env.REACT_APP_KEYCLOAK_URL,
  KEYCLOAK_REALM:
    fromRuntime("KEYCLOAK_REALM") || process.env.REACT_APP_KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID:
    fromRuntime("KEYCLOAK_CLIENT_ID") ||
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REDIRECT_URI:
    fromRuntime("KEYCLOAK_REDIRECT_URI") ||
    process.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  BACKEND_URL: fromRuntime("BACKEND_URL") || process.env.REACT_APP_BACKEND_URL,
  API: fromRuntime("API") || process.env.REACT_APP_API,
};

export default config;
